"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tick = function Tick() {
  return _react2.default.createElement(
    "g",
    { id: "tick" },
    _react2.default.createElement("polygon", { id: "Shape", points: "153.88 433.62 0 279.74 40.65 239.09 155.08 353.52 460.58 66 500 107.89" })
  );
};

exports.default = Tick;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Tick.js
// module id = 2996
// module chunks = 4